export function getStgoHourFromDate(date) { return date.toLocaleString('es-CL', { timeZone: 'America/Santiago', hour: 'numeric', minute: 'numeric', hour12: false }); }
